export default {
  name: 'GiftItemComponent',
  components: {},
  props: {
    giftData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      //- 是否打開幻燈片
      lightBoxVisible: false,
      //- 目前在第幾張圖片
      active: 0,
      //- 圖片方向, 用來配上 CSS 動畫
      direction: 1,
    }
  },
  methods: {
    //- 重置
    resetHandler: function() {
      let vm = this;
      vm.lightBoxVisible = false;
      vm.active = 0;
      vm.direction = 1;
    },
    handleHide: function() {
      let vm = this;
      vm.lightBoxVisible = false
    },
    touchHandler: function(e) {
      let vm = this;
      let direction = e;
      if (direction.type && direction.type === 'touchend') {
        direction = 'tap';
      }
      switch (direction) {
        case 'tap':
          vm.active = parseInt(e.target.id);
          //- 需要延遲零點一秒, 防止事件監聽太快, 立馬關閉視窗
          setTimeout(() => {
            vm.lightBoxVisible = true;
          }, 0.1);
          break;
        case 'left':
          //- 幻燈片加一
          vm.lightBoxChangeHandler(vm.active + 1);
          break;
        case 'right':
          //- 幻燈片減一
          vm.lightBoxChangeHandler(vm.active - 1);
          break;
        default:
          break;
      }
    },
    lightBoxChangeHandler(index) {
      let vm = this;
      vm.direction = index > this.active ? 1 : -1;
      vm.active = (index + this.totalImgArr) % this.totalImgArr;
    }
  },
  computed: {
    //- 動態計算圖片陣列長度
    totalImgArr() {
      let vm = this;
      let totalNum = 0;
      vm.$_.forEach(vm.giftData.pictures, function(i, k) {
        if (i !== null && i !== '' && i !== undefined) {
          totalNum += 1;
        }
      });
      return totalNum;
    }
  },
}